import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteDialogComponent } from '../../../../../shared/info-dialogs/delete-dialog/delete-dialog.component';
import { ReportList } from '../../../../informate/models/reports/data-sheet-report.model';

@Component({
    selector: 'app-instance-item-reports',
    templateUrl: './instance-item-reports.component.html',
    styleUrls: ['./instance-item-reports.component.scss'],
    standalone: false
})
export class InstanceItemReportsComponent implements OnInit {
    @Input() reportDataCopy: ReportList[];
    @Input() type: string;
    @Input()
    get reportData(): ReportList[] {
        return this._reportData;
    }
    set reportData(value: ReportList[]) {
        this._reportData = value;
    }

    @Output() isreportChecked: EventEmitter<any> = new EventEmitter<any>();

    tooltip_position = 'above';
    itemreport = [];
    _reportData: ReportList[];
    isCheckUncheck: boolean;
    searchText: string = '';

    constructor(private modalService: NgbModal) {}

    ngOnInit(): void {
        this.reportDataCopy = this.reportData;
    }

    searchResult(event) {
        if (!event.target.value) {
            this.reportData = this.reportDataCopy;
        } else {
            this.reportData = this.reportDataCopy.filter((item) => {
                return (item.name !== undefined ? item.name : '')
                    .trim()
                    .toLowerCase()
                    .replace(' ', '')
                    .includes(event.target.value.trim().replace(' ', '').toLowerCase());
            });
        }
    }

    // * handle check/uncheck of activity pack type
    checkUncheckReports(event, data: ReportList) {
        this.isCheckUncheck = true;
        let index = this.reportData.findIndex((type) => type.name == data.name);
        if (index !== -1) {
            this.reportData[index].isSelected = event.checked;
        }
        let datas = {
            checked: event.checked,
            data: data,
        };
        this.isreportChecked.emit(datas);
    }

    deleteReport(data: ReportList) {
        let dialogRef = this.modalService.open(DeleteDialogComponent, {
            size: 'sm',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.modalMessage = `Do you want to delete ${data.name} report? Reports scheduled might also lost(if any)`;
        dialogRef.result.then((resp) => {
            if (resp) {
                let payload: any = {};
                payload.activityPackId = data.reportId;
                payload.active = false;
                // this.deleteWorkpackApiCall(payload);
            }
        });
    }
}
